import { render, staticRenderFns } from "./trendsStackedIcon.vue?vue&type=template&id=e31c6cda&"
import script from "./trendsStackedIcon.vue?vue&type=script&lang=js&"
export * from "./trendsStackedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports